import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Set } from 'immutable';
import RecipientsHeader from 'messaging/components/RecipientsHeader';
import RecipientsList from 'messaging/components/RecipientsList';
import NewMessageBar from 'messaging/components/NewMessageBar';
import { filterRecipients } from 'messaging/actions/recipient';
import { sendMessage } from 'messaging/actions/message';

const markRecipientSelected = (recipients, selected) =>
  recipients.map(r => {
    return {
      ...r,
      isSelected: selected.has(r.id),
    };
  });

const mapStateToProps = state => ({
  isSending: state.messaging.mailbox.isSending,
  recipients: (
    state.messaging.recipients.filtered || state.messaging.recipients.items
  )
    .sortBy(r => r.name)
    .toArray(),
});
const mapDispatchToProps = dispatch => ({
  filterRecipients: filter => dispatch(filterRecipients(filter)),
  sendMessage: (message, to) => dispatch(sendMessage(message, to)),
});
class RecipientsPage extends React.Component {
  static propTypes = {
    isSending: PropTypes.bool,
    recipients: PropTypes.array,
    filterRecipients: PropTypes.func.isRequired,
    sendMessage: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      selected: Set(),
    };

    this.onRecipientSelected = this.onRecipientSelected.bind(this);
    this.onAllRecipientsSelected = this.onAllRecipientsSelected.bind(this);
    this.onAllRecipientUnselected = this.onAllRecipientUnselected.bind(this);
    this.onSendMessage = this.onSendMessage.bind(this);
  }

  onRecipientSelected(recipient) {
    const { selected } = this.state;
    if (selected.has(recipient)) {
      this.setState({
        selected: selected.delete(recipient),
      });
    } else {
      this.setState({
        selected: selected.add(recipient),
      });
    }
  }

  onAllRecipientsSelected() {
    const { recipients } = this.props;
    this.setState({
      selected: Set(recipients).map(r => r.id),
    });
  }

  onAllRecipientUnselected() {
    this.setState({
      selected: Set(),
    });
  }

  onSendMessage(message) {
    const { selected } = this.state;
    if (selected.size) {
      this.props.sendMessage(message, selected.toArray());
    }
  }

  render() {
    const { recipients, isSending } = this.props;
    const { selected } = this.state;

    const recipientsWithSelection = markRecipientSelected(recipients, selected);
    return (
      <div className="newMessage ui tab active">
        <div className="container">
          <div className="ui segments">
            <RecipientsHeader
              selectedCount={selected.size}
              onChange={this.props.filterRecipients}
              onSelectAll={this.onAllRecipientsSelected}
              onUnselectAll={this.onAllRecipientUnselected}
            />
            <RecipientsList
              recipients={recipientsWithSelection}
              onSelected={this.onRecipientSelected}
            />
            <NewMessageBar
              canSend={selected.size > 0}
              isSending={isSending}
              onSend={this.onSendMessage}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RecipientsPage);



// WEBPACK FOOTER //
// ./src/modules/messaging/pages/RecipientsPage.js